import { RouteNames } from "~~/server/enums";

export default defineNuxtRouteMiddleware(async (to, _) => {
  if (import.meta.server) return; // Skip middleware on the server side

  const { userState: user, userImageState: userImage } = useUser();
  const { $acquireTokenSilent } = useNuxtApp();

  // Wait for the client-side environment to initialize
  const accessToken = (await $acquireTokenSilent())?.accessToken;

  if (!accessToken) {
    if (to.name === "login") return;
    return navigateTo(RouteNames.LOGIN);
  }

  // Call and execute the user and userImage asyncData
  // to ensure they are fetched before the route is resolved
  user.execute();
  userImage.execute();

  // Redirect to `/upload` - at this point the token exists and user is logged in.
  if (to.name === "login" || to.path === '/') {
    return navigateTo(RouteNames.PREDICTION);
  }
});
